import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ApiMultipleResponse } from 'models/ApiModels';
import { ProductXrefItem } from 'models/ProductXref';
import { ReduxState } from 'redux/rootReducer';

/* ******************** Base Query ******************** */
const baseUrl = process.env.REACT_APP_BASE_URL_FLO_BEAR;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_FLO_BEAR;

export const floBearBaseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const floBearApi = createApi({
  reducerPath: 'floBearApi',
  baseQuery: floBearBaseQuery,
  tagTypes: ['ProductXrefItem', 'ProductXrefItems', 'DeletedProductXrefItem'],
  endpoints: (builder) => ({
    /* ****************** Business Endpoints ****************** */

    getProductXrefItem: builder.query<ProductXrefItem, { customerId: string; productId: string }>({
      query: ({ customerId, productId }) => ({
        url: `customers/${customerId}/customerXrefItems/${productId}`
      }),
      providesTags: ['ProductXrefItem']
    }),

    getProductXrefItems: builder.query<ApiMultipleResponse<ProductXrefItem>, { customerId: string; altItemId: string }>({
      query: ({ customerId, altItemId }) => ({
        url: `customers/${customerId}/customerXrefItems?productNumberContains=${altItemId}`
      }),
      providesTags: ['ProductXrefItems']
    }),

    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetProductXrefItemQuery, useGetProductXrefItemsQuery, useLazyGetProductXrefItemQuery, useGetVersionQuery, useGetApiNameQuery } = floBearApi;
